import { Pane } from "evergreen-ui";
import { ContentPosition, DetailsPageSection } from "../../common/DetailsPageSection";
import { FooterActionBar } from "../../common/FooterActionBar";
import { useStoreCreateContext } from "./StoreCreateContext";
import { useHistory } from "react-router-dom";
import { ImportThemesFormFields } from "./ImportThemesFormFields";

export const StoreCreateThemesTab = (): JSX.Element => {
    const history = useHistory();
    const {
        formValues,
        formStatusMessage,
        storefrontsData,
        storefrontsLoading,
        storefrontsError,
        setField,
        isFormValid,
        submitFormLoading,
        submitFormCalled,
        submitForm,
    } = useStoreCreateContext();

    return <Pane>
        <DetailsPageSection
            hideBorder={true}
            heading={
                <div className="jc-header-wrapper">
                    <h3 className="jc-header-title">Import Existing Themes</h3>
                    <p className="jc-header-optional">Optional</p>
                </div>
            }
            contentPosition={ContentPosition.left}
        >
            <ImportThemesFormFields
                existingStorefrontId={formValues.existingStorefrontId}
                themes={formValues.themes}
                storefrontsData={storefrontsData}
                storefrontsLoading={storefrontsLoading}
                storefrontsError={storefrontsError}
                updateExistingStorefrontId={(value: string) => setField('existingStorefrontId', value)}
                updateThemes={(value: string) => setField('themes', value)}
            />
        </DetailsPageSection>
        <FooterActionBar
            primaryButtonText={"Create Store"}
            isPrimaryLoading={submitFormCalled && submitFormLoading}
            primaryButtonDisabled={!isFormValid || (submitFormCalled && submitFormLoading)}
            onPrimaryClick={submitForm}
            showSecondaryButton={false}
            tertiaryButtonText={"Cancel Setup"}
            onTertiaryClick={() => {
                history.push("/stores");
            }}
            infoComponent={
                <p>{formStatusMessage}</p>
            }
        />
    </Pane >;
}
